import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './css/reset.css';
import './css/style.css';
import './css/stars.css';
import CV from './CV';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<CV />, document.getElementById('layout-container'));
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js